import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ProgramsPage } from './pages/ProgramsPage';
import { ClassesPage } from './pages/ClassesPage';
import { SchedulePage } from './pages/SchedulePage';
import { FacilityPage } from './pages/FacilityPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PersonalSafetyPage } from './pages/PersonalSafetyPage';
import { ChildBenefitsPage } from './pages/ChildBenefitsPage';
import { TeenBenefitsPage } from './pages/TeenBenefitsPage';
import { AdultBenefitsPage } from './pages/AdultBenefitsPage';
import { FamilyBenefitsPage } from './pages/FamilyBenefitsPage';
import { TaekwondoPage } from './pages/TaekwondoPage';
import { KickboxingPage } from './pages/KickboxingPage';
import { PrivateClassesPage } from './pages/PrivateClassesPage';
import { SelfDefenseSeminarsPage } from './pages/SelfDefenseSeminarsPage';
import { HomeschoolPage } from './pages/HomeschoolPage';
import { MidwestCup2026Page } from './pages/MidwestCup2026Page';
import { FreeTrialPage } from './pages/FreeTrialPage';
import { FormsPage } from './pages/FormsPage';
import { WomensSelfDefensePage } from './pages/WomensSelfDefensePage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/programs" element={<ProgramsPage data-id="element-5" />} data-id="element-4" />
        <Route path="/classes" element={<ClassesPage data-id="element-7" />} data-id="element-6" />
        <Route path="/schedule" element={<SchedulePage data-id="element-9" />} data-id="element-8" />
        <Route path="/facility" element={<FacilityPage data-id="element-11" />} data-id="element-10" />
        <Route path="/about" element={<AboutPage data-id="element-13" />} data-id="element-12" />
        <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
        <Route path="/personal-safety" element={<PersonalSafetyPage data-id="element-17" />} data-id="element-16" />
        <Route path="/selfdefensetips" element={<PersonalSafetyPage data-id="element-19" />} data-id="element-18" />
        <Route path="/child-benefits" element={<ChildBenefitsPage data-id="element-21" />} data-id="element-20" />
        <Route path="/benefits-for-children" element={<ChildBenefitsPage data-id="element-23" />} data-id="element-22" />
        <Route path="/teen-benefits" element={<TeenBenefitsPage data-id="element-25" />} data-id="element-24" />
        <Route path="/benefits-for-teens" element={<TeenBenefitsPage data-id="element-27" />} data-id="element-26" />
        <Route path="/adult-benefits" element={<AdultBenefitsPage data-id="element-29" />} data-id="element-28" />
        <Route path="/benefits-for-adults" element={<AdultBenefitsPage data-id="element-31" />} data-id="element-30" />
        <Route path="/family-benefits" element={<FamilyBenefitsPage data-id="element-33" />} data-id="element-32" />
        <Route path="/benefits-for-families" element={<FamilyBenefitsPage data-id="element-35" />} data-id="element-34" />
        <Route path="/classes/taekwondo" element={<TaekwondoPage data-id="element-37" />} data-id="element-36" />
        <Route path="/classes/kickboxing" element={<KickboxingPage data-id="element-39" />} data-id="element-38" />
        <Route path="/classes/homeschool" element={<HomeschoolPage data-id="element-41" />} data-id="element-40" />
        <Route path="/classes/private-classes" element={<PrivateClassesPage data-id="element-43" />} data-id="element-42" />
        <Route path="/classes/self-defense-seminars" element={<SelfDefenseSeminarsPage data-id="element-45" />} data-id="element-44" />
        <Route path="/midwest-cup-2026" element={<MidwestCup2026Page data-id="element-47" />} data-id="element-46" />
        <Route path="/forms" element={<FormsPage data-id="element-49" />} data-id="element-48" />
        <Route path="/free-trial" element={<FreeTrialPage data-id="element-51" />} data-id="element-50" />
        <Route path="/womens-self-defense-seminar-april-18-2026/p/womens-self-defense-workshop-toys-for-tots-toy-drive" element={<WomensSelfDefensePage data-id="element-53" />} data-id="element-52" />
      </Routes>
    </Router>;
}